var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orderlist bj order-container" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from1 },
        on: { Refresh: _vm.Refresh, search: _vm.search },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", icon: "el-icon-download" },
                    on: { click: _vm.exportHandle },
                  },
                  [_vm._v("导出")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex mt20" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: "",
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "logisticBusinessName",
                  align: "center",
                  label: "集配中心",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "taxpayerTypeName",
                  align: "center",
                  label: "纳税人类型",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  align: "center",
                  label: "供应商名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "uscc", align: "center", label: "税号" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierMobile",
                  align: "center",
                  label: "供应商电话",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.supplierMobile || "-") + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceStartTime",
                  align: "center",
                  label: "开通时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceEndTime",
                  align: "center",
                  label: "到期时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoicedAmount",
                  align: "center",
                  label: "已开票总金额",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceStatusName",
                  align: "center",
                  label: "状态",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.invoiceStatus == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleView(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            )
                          : _vm._e(),
                        scope.row.invoiceStatus == 2
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#f56c6c" },
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleTerminate(scope.row)
                                  },
                                },
                              },
                              [_vm._v("终止开票")]
                            )
                          : _vm._e(),
                        scope.row.invoiceStatus != 2
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#67c23a" },
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleOpen(scope.row)
                                  },
                                },
                              },
                              [_vm._v("开通")]
                            )
                          : _vm._e(),
                        scope.row.invoiceStatus != 2
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#f56c6c" },
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReject(scope.row)
                                  },
                                },
                              },
                              [_vm._v("驳回")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.from1.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.from1.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "center-dialog",
          attrs: {
            title: _vm.isView
              ? `${_vm.dialogForm.supplierName}的开票信息`
              : `请输入${_vm.dialogForm.supplierName}的开通的账户和密钥`,
            visible: _vm.openDialog,
            width: "400px",
            top: "0",
          },
          on: {
            "update:visible": function ($event) {
              _vm.openDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.dialogForm,
                "label-width": "80px",
                autocomplete: "off",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "税号：" } }, [
                _c("span", [_vm._v(_vm._s(_vm.dialogForm.uscc))]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "账户：" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入账户",
                      autocomplete: "off",
                      disabled: _vm.isView,
                    },
                    model: {
                      value: _vm.dialogForm.invoice_app_key,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "invoice_app_key", $$v)
                      },
                      expression: "dialogForm.invoice_app_key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "密钥：" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入密钥",
                      type: "password",
                      autocomplete: "new-password",
                      disabled: _vm.isView,
                    },
                    model: {
                      value: _vm.dialogForm.invoice_app_secret,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "invoice_app_secret", $$v)
                      },
                      expression: "dialogForm.invoice_app_secret",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.openDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.isView ? "关闭" : "取消"))]
              ),
              !_vm.isView
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitOpen },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }